interface HaccpDetailsReportConfiguration {
    ids: HaccpDetailsPageElementIds;
}

interface HaccpDetailsPageElementIds {
    addCommentModalId: string;
    addCommentModalReadingId: string;
}

$(document).on("turbolinks:load", function () {
    const configElement = document.getElementById("haccp-report-details-config");
    if (configElement) {
        const config: HaccpDetailsReportConfiguration = JSON.parse(configElement.innerHTML);
        new HaccpReportDetailsPage(config.ids);
    }
});

export class HaccpReportDetailsPage {
    constructor(private elementIds: HaccpDetailsPageElementIds) {
        ($(`#${elementIds.addCommentModalId}`) as any).on('shown.bs.modal', (e: JQuery.ClickEvent) => {
            const $buttonTrigger = $(e.relatedTarget);
            $(`#${elementIds.addCommentModalReadingId}`).val($buttonTrigger.data("snapshot-reading-id"));
        });
    }
}
